"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MuiIconButton = void 0;
var colors_1 = require("../colors");
exports.MuiIconButton = {
    defaultProps: {
        disableFocusRipple: true,
    },
    variants: [
        {
            props: { edge: 'end' },
            style: {
                marginRight: 0,
            },
        },
        {
            props: { size: 'small' },
            style: {
                height: 32,
                width: 32,
            },
        },
        {
            props: { color: 'default' },
            style: {
                color: '#000',
                '&.Mui-disabled': {
                    color: colors_1.tannerGray['400'],
                },
                '&:hover, &:focus-visible': {
                    backgroundColor: colors_1.tannerGray['100'],
                },
            },
        },
        {
            props: { color: 'white' },
            style: {
                color: '#000',
                backgroundColor: colors_1.tannerWhite,
                '&.Mui-disabled': {
                    color: '#000',
                    backgroundColor: colors_1.tannerGray['600'],
                },
                '&:hover, &:focus-visible': {
                    backgroundColor: colors_1.tannerGray['200'],
                },
            },
        },
        {
            props: { color: 'black' },
            style: {
                color: colors_1.tannerWhite,
                backgroundColor: '#000',
                '&.Mui-disabled': {
                    color: colors_1.tannerWhite,
                    backgroundColor: colors_1.tannerGray['400'],
                },
                '&:hover, &:focus-visible': {
                    color: colors_1.tannerWhite,
                    backgroundColor: colors_1.tannerGray['800'],
                },
            },
        },
        {
            props: { color: 'info' },
            style: {
                color: colors_1.tannerSemantic.info.color,
                backgroundColor: 'inherit',
                '&.Mui-disabled': {
                    color: colors_1.tannerSemantic.info.color,
                    backgroundColor: colors_1.tannerGray['400'],
                },
                '&:hover, &:focus-visible': {
                    color: colors_1.tannerSemantic.info['600'],
                    backgroundColor: colors_1.tannerSemantic.info.background,
                },
            },
        },
        {
            props: { color: 'error' },
            style: {
                color: colors_1.tannerSemantic.error.color,
                backgroundColor: 'inherit',
                '&.Mui-disabled': {
                    color: colors_1.tannerSemantic.error.color,
                    backgroundColor: colors_1.tannerGray['400'],
                },
                '&:hover, &:focus-visible': {
                    color: colors_1.tannerSemantic.error['700'],
                    backgroundColor: colors_1.tannerSemantic.error.background,
                },
            },
        },
        {
            props: { color: 'success' },
            style: {
                color: colors_1.tannerSemantic.success.color,
                backgroundColor: 'inherit',
                '&.Mui-disabled': {
                    color: colors_1.tannerSemantic.info.color,
                    backgroundColor: colors_1.tannerGray['400'],
                },
                '&:hover, &:focus-visible': {
                    color: colors_1.tannerSemantic.success['600'],
                    backgroundColor: colors_1.tannerSemantic.success.background,
                },
            },
        },
        {
            props: { color: 'warning' },
            style: {
                color: colors_1.tannerSemantic.warning.color,
                backgroundColor: 'inherit',
                '&.Mui-disabled': {
                    color: colors_1.tannerSemantic.warning.color,
                    backgroundColor: colors_1.tannerGray['400'],
                },
                '&:hover, &:focus-visible': {
                    color: colors_1.tannerSemantic.warning['600'],
                    backgroundColor: colors_1.tannerSemantic.warning.background,
                },
            },
        },
    ],
    styleOverrides: {
        root: {
            color: '#000',
            borderRadius: 3,
            fontSize: 'inherit',
            height: 40,
            width: 40,
            transition: 'background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
            '&:focus': {
                ':not(:focus-visible)': {
                    outline: 'none',
                    border: 'none',
                },
            },
            '&:focus-visible': {
                outline: "3px solid ".concat(colors_1.tannerSemantic.info.color),
                outlineOffset: 3,
                transition: 'outline-offset 150ms',
            },
            '&:hover, &:focus-visible': {
                backgroundColor: colors_1.tannerGray['200'],
                color: colors_1.tannerBlack,
            },
        },
    },
};
//# sourceMappingURL=MuiIconButton.js.map